(function ($, app) {
    if (!$) {
        return;
    }

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': app.helpers.csrfToken(),
            Accept: 'application/json',
        },
    });

    let activeRequests = 0;
    let loaderTimer = null;

    function showLoader() {
        activeRequests += 1;
        window.clearTimeout(loaderTimer);
        loaderTimer = window.setTimeout(() => app.helpers.showLoader(), 120);
    }

    function hideLoader() {
        activeRequests = Math.max(activeRequests - 1, 0);

        if (activeRequests === 0) {
            window.clearTimeout(loaderTimer);
            app.helpers.hideLoader();
        }
    }

    $(document).on('ajaxSend', function (event, jqXHR, settings) {
        if (settings.global !== false) {
            showLoader();
        }
    });

    $(document).on('ajaxComplete', function (event, jqXHR, settings) {
        if (settings.global !== false) {
            hideLoader();
        }
    });

    app.ajax = {
        request(options) {
            return $.ajax(options).fail((xhr) => {
                if (xhr.status === 419) {
                    app.helpers.notify('error', 'Your session expired. Please sign in again.');
                }
            });
        },
    };
})(window.jQuery, window.ITConnect);
